import React from 'react'
import { List, ListItem } from '@mui/material'
import ArticleCard from './article-card'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    '& > :not(:first-child)': {
      marginTop: spacing(2)
    }
  }
}))

const TimeArticleList = props => {
  const classes = useStyles(props)
  const { articles, onArticleSelect } = props
  const testAttr = 'retention-time-article-list'
  return (
    <List data-test={testAttr} className={classes.root}>
      {articles.map((article, index) => (
        <ListItem key={article.locationId || index}>
          <ArticleCard
            data-test={`${testAttr}-item-${index}`}
            article={article}
            onSelect={onArticleSelect}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default TimeArticleList
